// extracted by mini-css-extract-plugin
export default {"Image":"Story_Image__-pKZd"};